(function($){
    $.widget.bridge('uitooltip', $.ui.tooltip);

    var scale_images = function(){

        var img = new Image();
        $('.background-image').each(function(){
            var e = $(this);
            var src = e.css('background-image').replace(/"/g,"").replace(/url\(|\)$/ig, "");
            img.onload = function() {
                width = this.width;
                height = this.height;
                (width < height) ? e.css({'background-size':'cover'}) : (width > height) ? e.css({'background-size':'100% auto'}) : e.css({'background-size':'100%'});
            };
            img.src = src;
        });
    };

    $.fn.extend({
        autoHeightTextarea: function() {
            var autoHeightTextarea_;
            autoHeightTextarea_ = function(element) {
                return jQuery(element).css({
                    'height': 'auto',
                    'overflow-y': 'hidden'
                }).height(element.scrollHeight);
            };
            return this.each(function() {
                return autoHeightTextarea_(this).on('input', function() {
                    return autoHeightTextarea_(this);
                });
            });
        }
    });
    $(document).ready(function(){
        // $("[title]").tooltip();
        scale_images();
    });

})(jQuery);

window.CourtMeNow = window.cmn = {
    Exception: function(message, errno){
        this.message = message;
        this.errno = errno;
    }
};

window.isset = (variable) => {
  return (variable !== null && typeof variable !== 'undefined' && variable !== 'undefined');
}

window.is_object = (variable) => {
  return (typeof variable === 'object');
}

window.is_string = (variable) => {
  return (typeof variable === 'string');
}

window.is_number = (variable) => {
  return (typeof variable === 'number');
}



// WEBPACK FOOTER //
// ./src/app/lib/app.jquery.fn.js